import cx from 'classnames';
import styles from 'partials/filed-message.module.scss';

export const FieldMessage = ({ text, type = 'error', className }) => {
	const boxClass = cx(styles.box, className, {
		[styles.boxRed]: type === 'error',
		[styles.boxBlue]: type === 'success'
	});

	return <div className={boxClass}>{text}</div>;
};
